<template>
    <vx-card :title='$t("VacationDays")' collapse-action>
        <div class="mt-6" v-if="vacations !== undefined">
            <vs-table v-model="selectedVacation" @selected="handleSelected" :data="vacations">
                <template slot="thead">
                    <vs-th>{{$t("StartTime")}}</vs-th>
                    <vs-th>{{$t("EndTime")}}</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].start">
                            {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                        </vs-td>
                        <vs-td :data="data[indextr].end">
                            {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip v-if="data[indextr].status === 0" color="primary">{{$t("Waiting")}}</vs-chip>
                            <vs-chip v-else-if="data[indextr].status === 1" color="success">{{$t("Confirmed")}}</vs-chip>
                            <div v-else-if="data[indextr].status === 2" style="display: flex">
                                <vx-tooltip :text="data[indextr].denial_reason">
                                    <vs-chip color="danger">{{$t("Rejected")}}</vs-chip>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup :title="$t('Edit')" :active.sync="editVacationPrompt">

            <p class="mt-6">{{$t("Description")}}</p>
            <vs-textarea :disabled="editVacation.status !== 0" v-model="editVacation['notes']" class="w-full" />
            <vs-divider/>
            <vs-button :disabled="editVacation.status !== 0" style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editVacationRequest">{{$t("Change")}}</vs-button>
            <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeVacationRequest">{{$t("Delete")}}</vs-button>
        </vs-popup>

    </vx-card>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr,
        },
        props: {
            userId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {

                selectedVacation: {},

                vacations: [],
                editVacation: {},
                editVacationPrompt: false,
                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
            }
        },
        methods: {
            handleSelected(tr) {
                if (tr.status === 0) {
                    this.editVacation = tr;
                    this.editVacationPrompt = true;
                }else{
                    this.selectedVacation = {}
                }

            },
            updateVacations() {
                const thisIns = this;
                this.$http.get('/api/v1/profile/vacation/')
                    .then(function (response) {
                        thisIns.vacations = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editVacationRequest() {
                const thisIns = this;
                this.$http.put('/api/v1/profile/vacation/' + this.selectedVacation.id, {
                    notes: thisIns.editVacation.notes
                }).then(function () {
                    thisIns.updateVacations();
                    thisIns.editVacationPrompt = false;
                }).catch(function (error) {
                    thisIns.editVacationPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeVacationRequest(){
                const thisIns = this;
                this.$http.delete('/api/v1/profile/vacation/' + this.selectedVacation.id)
                    .then(function () {
                        thisIns.updateVacations();
                        thisIns.editVacationPrompt = false;
                    }).catch(function (error) {
                    thisIns.editVacationPrompt = false;
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
            }
        },
        watch: {
            editVacationPrompt: function () {
                if(!this.editVacationPrompt){
                    this.selectedVacation = {}
                }
            }
        },
        created() {
            this.updateVacations();
        }
    }

</script>
